export const STREAM_ORIGIN_TYPE = {
    FLUSSONIC: 'flussonic',
    WOWZA: 'wowza',
};
